import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConductorDTO } from '../../../dtos/conductor.dto';
import { ConductorService } from '../../services/conductor.service';
import moment from "moment";
import {JornadaDTO} from "../../../dtos/jornada.dto";
import {ApiService} from "../../services/api.service";
import {JornadaService} from "../../services/jornada.service";
import {EventService} from "../../services/event.service";
import {GeneralResponseDTO} from "../../../dtos/response/general.response.dto";
import {AppMessage} from "../../app.message";
import {SucursalDTO} from "../../../dtos/sucursal.dto";
import {NgSelectModule} from "@ng-select/ng-select";
import {SucursalService} from "../../services/sucursal.service";
import {FormsModule} from "@angular/forms";
import {HttpErrorResponse} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {MovilDTO} from "../../../dtos/movil.dto";
import {GetListaSucursalesResponseDTO} from "../../../dtos/response/getListaSucursales.response.dto";
import {NgIf} from "@angular/common";
import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-modal-cambiar-sucursal-cb',
  standalone: true,
  imports: [
    NgSelectModule,
    FormsModule,
    NgIf
  ],
  templateUrl: './modal-cambiar-sucursal-cb.component.html',
  styleUrl: './modal-cambiar-sucursal-cb.component.scss'
})
export class ModalCambiarSucursalCbComponent implements OnInit {

  public jornada: JornadaDTO;
  public sucursalSeleccionada: SucursalDTO;
  public listadoSucursalesDisponibles: Array<SucursalDTO> = [];

  constructor(private modalRef: BsModalRef, private apiService: ApiService, private jornadaService: JornadaService,
              private eventService: EventService, private sucursalService: SucursalService, 
              private toastr: ToastrService, private userService: UserService) {

    this.eventService.subscribe('JORNADA_ACTUALIZADA_MQTT_EVENT', (jornada: JornadaDTO) => {
      if(jornada.uuid == this.jornada.uuid) {
        this.jornada = jornada;
      }
    })
  }

  ngOnInit(): void {
    this.jornada = this.jornadaService.getJornadaSeleccionada();
    //this.listadoSucursalesDisponibles =  this.sucursalService.getSucursalesSeleccionadas();
    this.getListaSucursales();
  }

  close() {
    this.modalRef.hide();
  }

  tienePermisoCambiarSucursalCB(): boolean {
    return this.userService.tienePermiso('JORNADA_CAMBIAR_SUCURSAL');
  }

  getListaSucursales() {
    this.apiService.getListaSucursales().subscribe(
      (resp) => this.getListaSucursalesSuccess(resp),
      (error) => this.getListaSucursalesError(error)
    );
  }

  getListaSucursalesSuccess(getListaSucursalesResponseDTO: GetListaSucursalesResponseDTO) {
    console.log('exito get sucursales', getListaSucursalesResponseDTO);
    this.listadoSucursalesDisponibles = getListaSucursalesResponseDTO.data;
  }

  getListaSucursalesError(error: HttpErrorResponse) {
    console.log('error get sucursales', error);
    const msg = error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_CAMBIAR_SUCURSAL_CONDUCTORES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  putActualizarSucursalJornada() {
    if(!this.sucursalSeleccionada) {
      //alert('Debe seleccionar una sucursal');
      this.toastr.warning('Debe seleccionar una sucursal', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    this.apiService.putActualizarSucursalJornada(this.jornada.uuid, this.sucursalSeleccionada.uuid)
      .subscribe(res => this.putActualizarSucursalJornadaSuccess(res), error => this.putActualizarSucursalJornadaError(error));
  }

  putActualizarSucursalJornadaSuccess(generalResponseDTO: GeneralResponseDTO) {
    console.log('put sucursal joranda success', generalResponseDTO);
    //alert(generalResponseDTO.msg);
    //this.alertService.presentAlertaInfo(generalResponseDTO.msg);
    this.toastr.success(generalResponseDTO.msg, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
    this.eventService.publish('CAMBIAR_SUCURSAL_JORNADA_SUCCESS');
    this.close();
  }

  putActualizarSucursalJornadaError(error: HttpErrorResponse) {
    console.log('put sucursal jornada error', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_CAMBIAR_SUCURSAL_JORNADA_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

}
